import { persistor, store } from './store';
import { BrowserRouter } from 'react-router';
import { PersistGate } from 'redux-persist/es/integration/react';
import { Provider as ReduxProvider } from 'react-redux';
import ErrorBoundary from '@/components/Errors/ErrorBoundary';
import AppRoutes from '@/routes/AppRoutes';
import ScrollToTop from '@/components/common/ScrollToTop';
import AppProviders from '@/providers/AppProviders';
import ExperimentsProvider from '@/providers/ExperimentsProvider';
import { CookieProvider } from '@/components/Cookies/CookieProvider';
import { StrictMode } from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// styled-components v6 forwards every prop to the DOM unless told otherwise;
// this restores the v5 behaviour (filter non-HTML props for DOM targets,
// forward everything to React components) so styled wrappers don't spam
// "React does not recognize the X prop" warnings.
const shouldForwardProp = (propName, target) =>
  typeof target === 'string' ? isPropValid(propName) : true;

const App = () => (
  <StrictMode>
    <BrowserRouter useTransitions={true}>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <CookieProvider>
              <ScrollToTop />
              <ErrorBoundary>
                <AppProviders>
                  <ExperimentsProvider>
                    <AppRoutes />
                  </ExperimentsProvider>
                </AppProviders>
              </ErrorBoundary>
            </CookieProvider>
          </PersistGate>
        </ReduxProvider>
      </StyleSheetManager>
    </BrowserRouter>
  </StrictMode>
);

export default App;
